export default __webpack_public_path__ + "static/media/usr.485504ff.png";